<template>
  <div>
    <a :class="classes" @click="showForm"><slot>Solicite orçamento para abertura de sua empresa</slot></a>
  </div>
</template>

<script>
export default {
  name: 'BotaoConstituicaoDeEmpresa',

  props: ['classes'],

  data () {
    return {
      isOpen: false
    }
  },

  methods: {
    showForm () {
      this.isOpen = !this.isOpen
      this.$eventBus.$emit('CONSTITUICAO_DE_EMPRESA', this.isOpen)
    }
  }
}
</script>



// WEBPACK FOOTER //
// BotaoConstituicaoDeEmpresa.vue?dbf33d64